<template>
  <div class='dictionariesAd'>
    <div class='boxLeft' ref='left'>
      <el-button size='mini' type='primary' @click='addOrEditDictionaries(true)'>新增</el-button>
      <el-button size='mini' type='primary' @click='addOrEditDictionaries(false)'>编辑</el-button>
      <el-button size='mini' type='danger' @click='deleteDictionaries'>删除</el-button>
      <el-input v-model='treeText' class='mt10' size='mini'></el-input>
      <el-tree :data='data'
               v-loading='leftLoad'
               node-key='id'
               default-expand-all
               highlight-current
               ref='tree'
               :props="{
                children: 'sonCategory',
                label: 'categoryName',
                value:'id'
              }"
               :filter-node-method='filterNode'
               @node-click='handleNodeClick' />
      <!--      :default-expanded-keys="expanded"-->
    </div>
    <div class='boxRight' ref='right'>
      <div>
        <el-form :inline='true' :model='formInline' class='demo-form-inline' size='mini'>
          <el-form-item label='字典值'>
            <el-input v-model='formInline.value' placeholder='请输入字典值' />
          </el-form-item>
          <el-form-item label='状态'>
            <el-select v-model='formInline.status' filterable placeholder='请选择状态'>
              <el-option label='全选' value=''></el-option>
              <el-option label='启用' value='1'></el-option>
              <el-option label='停用' value='0'></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type='primary' @click='onSubmit'>搜 索</el-button>
            <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
            <el-button type='danger' icon='el-icon-plus' @click='add'>新增字典</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-table :data='tableData' border stripe style='width: 100%' size='mini'
                  :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
                  :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
                  v-loading='tableLoad'>
          <el-table-column label='序号' align='center' type='index' width='50' />
          <el-table-column label='显示值' prop='classaName' align='center' />
          <el-table-column label='说明' prop='classbName' align='center' />
          <el-table-column label='创建时间' prop='createTime' align='center'>
            <template slot-scope='scope'>
              {{ scope.row.createTime|formatTime }}
            </template>
          </el-table-column>
          <el-table-column label='状态' prop='states' align='center'>
            <template slot-scope='scope'>
              {{ scope.row.states|statesFormat }}
            </template>
          </el-table-column>
          <el-table-column label='操作' align='center' width='300'>
            <template slot-scope='scope'>
              <el-button size='mini' :type="scope.row.states===1?'danger':'success'"
                         @click='prohibit(scope.row.id)'>
                {{ scope.row.states === 1 ? '禁用' : '启用' }}
              </el-button>
              <el-button size='mini' type='primary' @click='modifyMsg(scope.row)'
              >修改
              </el-button>
              <el-button size='mini' type='danger' @click='deleteData(scope.row.id)'>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='page' style='margin-top: 20px'>
        <el-pagination
          @size-change='handleSizeChange'
          @current-change='handleCurrentChange'
          :current-page.sync='formInline.Page'
          :page-size='formInline.rows'
          :page-sizes='[10, 20, 30, 40]'
          background
          layout='total, sizes, prev, pager, next, jumper'
          :total='total' />
      </div>


    </div>
    <el-dialog :title='dialogTitle' :visible.sync='addShow' width='700px' center>
      <div style='padding: 20px;width: 100%'>
        <el-form :model='addForm' :rules='rules' label-width='150px' ref='ruleForm'
                 class='demo-ruleForm'>
          <el-form-item label='字典名：' prop='classaName'>
            <el-input size='mini' style='width: 70%' v-model='addForm.classaName'
                      placeholder='请输入字典名'></el-input>
          </el-form-item>
          <el-form-item label='说明：'>
            <el-input
              style='width: 70%'
              type='textarea'
              :autosize='{ minRows: 2, maxRows: 4}'
              placeholder='请输入字典说明'
              v-model='addForm.classaRemark'>
            </el-input>
          </el-form-item>
          <el-form-item style='display: flex;justify-content: center;' label-width='0px'>
            <el-button size='medium' class='searchBtn' :loading='addLoad' @click='addClick'>
              {{ dialogTitle === '修改字典' ? '修改' : '确认' }}
            </el-button>
            <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!-- 新增字典 -->
    <dictionaries-form ref='dictionariesFormRef' @getParamCategory='getParamCategory' />
  </div>
</template>

<script>
  import {
    getParamCategory,
    paramCategoryPageList,
    paramCategoryAddCategoryAttr,
    paramCategoryUpdateCategoryAttr, paramCategoryIsEnable,
    paramCategoryDelete, categoryDelete,
  } from '@/service/basicfile';
  import { formatTime } from '@/config/mUtils';
  import dictionariesForm from '@/views/basicfile/dictionaries/components/dictionariesForm';

  export default {
    name: 'dictionariesAd',
    components: { dictionariesForm },
    data() {
      return {
        leftLoad: false,//左侧刷新
        data: [],
        total: 0,

        formInline: {
          value: '',
          status: '',
          rows: 10,
          Page: 1,
        },
        tableData: [],
        tableLoad: false,
        categoryCd: '',//保存id初始分页查询
        addShow: false,
        addLoad: false,
        addForm: {
          classaName: '',
          classaRemark: '',
        },
        dialogTitle: '',
        rules: {
          classaName: {
            required: true,
            message: '请输入字典名',
            trigger: 'blur',
          },
          classaRemark: {
            required: true,
            message: '请输入字典说明',
            trigger: 'blur',
          },
        },
        treeText: '',
        category: [],
      };
    },
    watch: {
      treeText(val) {
        this.$refs.tree.filter(val);
      },
    },
    filters: {
      statesFormat(value) {
        switch (value) {
          case 1:
            return '启用中';
          case 0:
            return '禁用中';
        }
      },
      formatTime(val) {
        if (val) {
          return formatTime(val, 'yyyy-mm-dd hh:ii:ss');
        } else {
          return '';
        }
      },
    },
    mounted() {
      this._getParamCategory();

    },
    methods: {
      addOrEditDictionaries(isAdd) {
        isAdd ? this.$refs.dictionariesFormRef.openDialog(this.data) : this.$refs.dictionariesFormRef.openDialog(this.data, this.category);
      },
      deleteDictionaries() {
        this.$confirm(`确认删除 字典-${this.category.categoryName} 吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const {
              status,
              message,
            } = await categoryDelete(this.category.id);
            if (status !== 0) return this.$message.warning(message);
            this.$message.success('删除成功');
            await this.getParamCategory();
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            });
          });
      },
      filterNode(value, data) {
        console.log(value, data);
        if (!value) return true;
        return data.categoryName.indexOf(value) !== -1;
      },
      async _getParamCategory() {
        this.leftLoad = true;
        let res = await getParamCategory();
        this.leftLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.data = res.data;
        //保存第一个的id
        this.categoryCd = this.data[0].sonCategory[0].id;
        this.category = this.data[0].sonCategory[0];
        await this._paramCategoryPageList();
        //设置默认选中第一个
        this.$nextTick(() => {
          // console.log(this.categoryCd)
          this.$refs.tree.setCurrentKey(this.categoryCd);
        });
      },
      async getParamCategory() {
        this.leftLoad = true;
        let res = await getParamCategory();
        this.leftLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.data = res.data;
      },
      async _paramCategoryPageList() {
        this.tableLoad = true;
        let res = await paramCategoryPageList(
          {
            ...this.formInline,
            classaName: this.formInline.value,
            states: this.formInline.status,
            paramId: this.categoryCd,
          },
        );
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.tableData = res.data.records;
        this.total = res.data.total;

      },
      // 点击字典树
      handleNodeClick(data) {
        this.category = data;
        this.categoryCd = data.id;
        this._paramCategoryPageList();
      },
      handleSizeChange(val) {
        this.formInline.rows = val;
        this._paramCategoryPageList();
      },
      handleCurrentChange(val) {
        this.formInline.Page = val;
        this._paramCategoryPageList();
      },
      handleChange(res) {
        console.log(res);
      },
      onSubmit() {
        this._paramCategoryPageList();
      },
      add() {
        this.dialogTitle = '新增字典';
        this.addShow = true;
      },
      addClick() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.addLoad = true;
            let obj = {
              paramId: this.categoryCd,
              ...this.addForm,
              classbName: this.addForm.classaRemark,
            };
            let res = this.dialogTitle === '新增字典' ? await paramCategoryAddCategoryAttr(obj) : await paramCategoryUpdateCategoryAttr(obj);
            this.addLoad = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._paramCategoryPageList();
            this.dialogClose();
          } else {

          }
        });
      },
      dialogClose() {
        this.$refs.ruleForm.resetFields();
        this.addShow = false;
      },
      modifyMsg(row) {
        this.addShow = true;
        this.dialogTitle = '修改字典';
        this.addForm = {
          id: row.id,
          classaName: row.classaName,
          classaRemark: row.classbName,
        };
      },
      resetBtn() {
        for (let formInlineKey in this.formInline) {
          this.formInline[formInlineKey] = '';
          this.formInline.rows = 10;
          this.formInline.Page = 1;
        }
      },
      async prohibit(id) {
        console.log(id);
        let res = await paramCategoryIsEnable(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._paramCategoryPageList();
      },
      /**
       * 删除
       * @param id 表格id
       */
      deleteData(id) {
        this.$confirm('确认删除数据吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await paramCategoryDelete(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._paramCategoryPageList();
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            });
          });
      },
    },
  };
</script>

<style lang='scss' scoped>
  .dictionariesAd {
    display: flex;
    padding: 20px;
    width: 100%;
    /*height:100%;*/
    ::v-deep.boxLeft {
      background-color: #FFF;
      min-height: 100%;
      width: 20%;
      padding: 10px;
      margin-right: 10px;
      /*height: 100%;*/
      .el-tree {
        height: 100%;
        background-color: rgba(255, 255, 255, 0);

        .el-tree-node__content:hover {
          background-color: #f1f2f3;
        }

        .el-tree-node:focus > .el-tree-node__content {

          background-color: #f1f2f3;


        }

        .el-tree-node.is-current > .el-tree-node__content {
          background-color: #f1f2f3;
        }
      }
    }

    .boxRight {
      background-color: white;
      margin-left: 10px;
      margin-top: 10px;
      padding: 10px;
      width: 70%;
    }

    ::v-deep {

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

    }

  }
</style>
